import { render, staticRenderFns } from "./SaveSellerForm.vue?vue&type=template&id=370b55ea&"
import script from "./SaveSellerForm.vue?vue&type=script&lang=js&"
export * from "./SaveSellerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports